<template>
  <nav class="consultation-dates" aria-label="Consultas">
    <span class="consultation-dates__title">Consultas</span>
    <div ref="dates" class="consultation-dates__items">
      <button type="button" class="consultation-dates__date" :class="{ 'is-active': currentActive }"
              :aria-pressed="currentActive" aria-label="Abrir consulta atual" @click="$emit('current')">
        {{ currentLabel }}
      </button>
      <button v-for="history in histories.slice(0, visibleCount)" :key="history.date" type="button"
              class="consultation-dates__date" :class="{ 'is-active': isSelected(history.date) }"
              :aria-pressed="isSelected(history.date)" :aria-label="`Consultar atendimento de ${formatDate(history.date, 'DD/MM/YYYY')}`"
              @click="$emit('select', history.date)">
        {{ formatDate(history.date) }}
      </button>
      <button v-if="visibleCount < histories.length" type="button" class="consultation-dates__all"
              @click="$emit('all')">Todos</button>
    </div>
    <div ref="measure" class="consultation-dates__measure" aria-hidden="true">
      <span class="consultation-dates__date">{{ currentLabel }}</span>
      <span v-for="history in histories" :key="history.date" class="consultation-dates__date">{{ formatDate(history.date) }}</span>
      <span class="consultation-dates__all">Todos</span>
    </div>
  </nav>
</template>

<script>
import moment from 'moment';

export default {
  name: 'AttendanceHistoryTimeline',
  props: {
    histories: { type: Array, required: true },
    selectedDate: { type: String, default: null },
    currentDate: { type: String, default: null },
    currentActive: { type: Boolean, default: true },
  },
  emits: ['select', 'current', 'all'],
  data() {
    return { visibleCount: 0 };
  },
  computed: {
    currentLabel() {
      const date = moment(this.currentDate || undefined);
      return `${date.format('DD/MM')}${date.isSame(moment(), 'day') ? ' hoje' : ' atual'}`;
    },
  },
  watch: {
    histories: { handler() { this.$nextTick(this.fitDates); }, deep: true },
    currentLabel() { this.$nextTick(this.fitDates); },
  },
  mounted() {
    this.resizeObserver = new ResizeObserver(this.fitDates);
    this.resizeObserver.observe(this.$refs.dates);
    this.fitDates();
  },
  beforeUnmount() {
    this.resizeObserver.disconnect();
  },
  methods: {
    formatDate(date, format = 'DD/MM') {
      return moment(date).format(format);
    },
    isSelected(date) {
      return !!this.selectedDate && moment(date).isSame(this.selectedDate, 'day');
    },
    fitDates() {
      const widths = Array.from(this.$refs.measure.children, item => item.getBoundingClientRect().width);
      const available = this.$refs.dates.clientWidth;
      const gap = 8;
      const fullWidth = widths.slice(0, -1).reduce((sum, width) => sum + width, 0) + this.histories.length * gap;
      if (fullWidth <= available) {
        this.visibleCount = this.histories.length;
        return;
      }
      let used = widths[0] + widths[widths.length - 1] + gap;
      let count = 0;
      for (const width of widths.slice(1, -1)) {
        if (used + gap + width > available) break;
        used += gap + width;
        count++;
      }
      this.visibleCount = count;
    },
  },
};
</script>

<style scoped>
.consultation-dates { position: relative; display: flex; align-items: center; gap: 12px; min-width: 0; margin-bottom: 16px; padding: 6px 0; }
.consultation-dates__title { flex-shrink: 0; color: #35303d; font-size: 12px; font-weight: 600; }
.consultation-dates__items { position: relative; isolation: isolate; display: flex; align-items: center; gap: 8px; flex: 1; min-width: 0; }
.consultation-dates__items > button + button::before { content: ''; position: absolute; right: 100%; top: 50%; width: 9px; height: 1px; background: #ddd9e2; z-index: -1; }
.consultation-dates__items > button { position: relative; }
.consultation-dates__date, .consultation-dates__all { display: inline-flex; align-items: center; justify-content: center; flex-shrink: 0; box-sizing: border-box; height: 28px; padding: 0 12px; border: 1px solid #ddd9e2; border-radius: 999px; background: #fff; color: #55505e; font-family: inherit; font-size: 12px; line-height: 1; white-space: nowrap; cursor: pointer; }
.consultation-dates__date:hover { border-color: #ae79a0; background: #faf4f8; }
.consultation-dates__date.is-active { background: #780f5a; border-color: #780f5a; color: #fff; }
.consultation-dates__all { background: #eee7f5; border-color: #e0d3eb; color: #694487; font-weight: 600; }
.consultation-dates__all:hover { background: #e4d7ef; }
.consultation-dates button:focus-visible { outline: 2px solid #ae79a0; outline-offset: 2px; }
.consultation-dates__measure { position: absolute; display: flex; gap: 8px; visibility: hidden; pointer-events: none; height: 0; overflow: hidden; max-width: 100%; }
</style>
